/**
 * Checks if two elements are within the same table
 * @param sourceElement - The source element from the drag event
 * @param selfElement - The current element (ref.current)
 * @returns true if both elements are within the same table
 */
export const isSameTable = (sourceElement: Element, selfElement: Element | null): boolean => {
	const sourceTable = sourceElement.closest('table');
	const selfTable = selfElement?.closest('table');

	return sourceTable === selfTable;
};
